import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FONT_APPLE_UI, IconGlobe, IconMic, IconMessageCircle, IconSearch, IconUser } from './talkAppleIcons';

const tabs = [
  { path: '/', label: 'ひろば', Icon: IconGlobe },
  { path: '/talk', label: 'トーク', Icon: IconMic },
  { path: '/chat', label: 'チャット', Icon: IconMessageCircle },
  { path: '/search', label: '検索', Icon: IconSearch },
  { path: '/profile', label: 'マイページ', Icon: IconUser },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  return (
    <nav style={styles.nav} aria-label="メインナビゲーション">
      <div style={styles.inner}>
        {tabs.map(tab => {
          const path = tab.path === '/profile' ? `/profile/${user?.id}` : tab.path;
          const active = tab.path === '/'
            ? location.pathname === '/'
            : tab.path === '/profile'
              ? location.pathname === '/profile' || location.pathname === `/profile/${user?.id}`
              : location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`);
          const Icon = tab.Icon;
          return (
            <button data-control="nav" data-control-id="BottomNav-tab" type="button" key={tab.path} aria-current={active ? 'page' : undefined} aria-label={tab.label} style={styles.tab} onClick={() => navigate(path)}>
              <div style={styles.iconWrap}>
                <span style={{ ...styles.icon, color: active ? 'var(--primary-dark)' : 'var(--text-secondary)' }}><Icon size={24} /></span>
              </div>
              <span
                style={{
                  ...styles.label,
                  ...(active ? styles.labelActive : {}),
                }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

const styles = {
  nav: { position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 'var(--app-max-w)', fontFamily: FONT_APPLE_UI, background: 'var(--surface)', borderTop: '1px solid var(--border)', zIndex: 100, paddingBottom: 'env(safe-area-inset-bottom)' },
  inner: { display: 'flex', padding: 8, height: 80 },
  tab: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4, background: 'none', border: 'none', cursor: 'pointer', padding: '2px' },
  iconWrap: { width: 36, height: 27, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  icon: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  label: { display: 'block', color: 'var(--text-secondary)', fontSize: 10, lineHeight: 1.5, fontWeight: 500, whiteSpace: 'nowrap' },
  labelActive: { color: 'var(--text)', fontWeight: 700 },
};
